var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#4987CF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0C20.7396 0 21.7995 0.4401 22.6797 1.32031C23.5599 2.20053 24 3.26041 24 4.5V19.5C24 20.7396 23.5599 21.7995 22.6797 22.6797C21.7995 23.5599 20.7396 24 19.5 24H16.5625V14.7031H19.6719L20.1406 11.0781H16.5625V8.76563C16.5625 8.18229 16.6849 7.74479 16.9297 7.45313C17.1745 7.16146 17.651 7.01563 18.3594 7.01563L20.2656 7V3.76563C19.6094 3.67187 18.6823 3.625 17.4844 3.625C16.0677 3.625 14.9349 4.04166 14.0859 4.875C13.237 5.70834 12.8125 6.88541 12.8125 8.40625V11.0781H9.6875V14.7031H12.8125V24H4.5C3.26041 24 2.20053 23.5599 1.32031 22.6797C0.4401 21.7995 0 20.7396 0 19.5V4.5C0 3.26041 0.4401 2.20053 1.32031 1.32031C2.20053 0.4401 3.26041 0 4.5 0H19.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9b941279785a3019dee8720f5d46b0db.svg";
export { ForwardRef as ReactComponent };